import React from "react";
import Footer from "components/Footer";
import Navbar from "components/Navbar";
import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function MainLayout({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    AOS.init();
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, []);

  if (isLoading) {
    return <div className="loader fixed bg-white inset-0"></div>;
  }
  return (
    <main className="">
      <Navbar />
      <div className="">{children}</div>
      <Footer />
    </main>
  );
}

export default MainLayout;
